// extracted by css-extract-rspack-plugin
export default {"hideDefaultIcons":"LabeledTimeInput_hideDefaultIcons__04OmT","disabled":"LabeledTimeInput_disabled__R3tPR"};